// iMPORTS
// OHS
import OHSWidget from '../../../../../onehivesystems/js/OHSWidget';


// COMPONENT
export default function InsertableFields (props) {
   // Component
   return (
      <OHSWidget onehive={props.onehive} title="Insertable Fields">
         <div className='oneport-commands-insertablefields'>
            <div className='oneport-commands-insertablefields-item'>
               <div className='oneport-commands-insertablefields-item-name'>
                  <p>Port Name</p>
               </div>
               <div className='oneport-commands-insertablefields-item-value'>
                  <p>###default_port_name###</p>
               </div>
            </div>
            {props.parent.fields && props.parent.fields.length > 0 && props.parent.fields.map(function (field, i) {
               return (
                  <div key={`oneport-commands-insertablefields-item-${i}`} className='oneport-commands-insertablefields-item'>
                     <div className='oneport-commands-insertablefields-item-name'>
                        <p>{field.name.value}</p>
                     </div>
                     <div className='oneport-commands-insertablefields-item-value'>
                        <p>###{field.name.value}###</p>
                     </div>
                  </div>
               );
            })}
         </div>
      </OHSWidget>
   );
}